import axios from 'axios'
import {
    DiagnosisConsultationCreateRequest,
    DiagnosisConsultationFinalizationRequest,
    DiagnosisConsultationResponse
} from '@/modules/diagnosisModule/services/diagnosis-consultation/diagnosis-consultation.dto'

class DiagnosisConsultationService {
    async getConsultations(laboratoryId: number, caseId: number): Promise<DiagnosisConsultationResponse[]> {
        const response = await axios.get<DiagnosisConsultationResponse[]>(`/diagnosis/laboratories/${laboratoryId}/cases/${caseId}/consultations`)
        return response.data
    }

    async createConsultation(laboratoryId: number, caseId: number, request?: DiagnosisConsultationCreateRequest): Promise<DiagnosisConsultationResponse> {
        const response = await axios.post<DiagnosisConsultationResponse>(`/diagnosis/laboratories/${laboratoryId}/cases/${caseId}/consultations`, request)
        return response.data
    }

    async patchConsultation(laboratoryId: number, caseId: number, consultationId: number, request?: DiagnosisConsultationFinalizationRequest): Promise<DiagnosisConsultationResponse> {
        const response = await axios.put<DiagnosisConsultationResponse>(`/diagnosis/laboratories/${laboratoryId}/cases/${caseId}/consultations/${consultationId}`, request)
        return response.data
    }

    async deleteConsultation(laboratoryId: number, caseId: number, consultationId: number): Promise<void> {
        const response = await axios.delete<void>(`/diagnosis/laboratories/${laboratoryId}/cases/${caseId}/consultations/${consultationId}`)
        return response.data
    }
}

export const diagnosisConsultationService = new DiagnosisConsultationService()
